(function (window, $, app) {
    var Math = window.Math;
    
    function Template() {
        this.compile = function (tpl) {
            var template;
            
            tpl = tpl.trim();
            
            if (window.Handlebars) {
                return window.Handlebars.compile(tpl);
            }
            
            return function (context) {
                var conditional_parse = tpl.replace(/{{\s*#if ([A-z0-9$_-]+)\s*}}((?:[\s\S](?!{\/if|{\s*else))+)?(?:{{\s*else\s*}})?((?:[\s\S](?!{\/if))+)?{{\s*\/if\s*}}/gm, function (match, g1, g2, g3) {
                    if (context.hasOwnProperty(g1)) {
                        if (g2) {
              
                            return g2;
                        } else {

                            return '';
                        }
                    } else {
                        if (g3) {
              
                            return g3;
                        } else {
                            
                            return '';
                        }
                    }
                });
                var rendered = conditional_parse.replace(/{{\s*([A-z0-9$_-]+)\s*}}/g, function (match, g1) {
                    if (context.hasOwnProperty(g1)) {
                        return context[g1];
                    }
              
                    return g1;
                });
                
                return rendered;
            };
        };
    }
    
    app.registerModule('Template', new Template());
})(window, jQuery, app);
